import React from 'react';
import '../ContactUs/ContactUs.scss';
import {graphql, useStaticQuery} from "gatsby";
import Img from "gatsby-image";


const ContactUsBackground=()=> {
    const contactUs = useStaticQuery(graphql`
    query contactUsQuery {
        strapiContactUs {
          BackgroundImage {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          BackgroundImageMobile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      `);

 return( <div>
        <Img
            className={"contactUSBackgroundImg"}
            alt={contactUs.strapiContactUs.BackgroundImage.childImageSharp.fluid}
            fluid={contactUs.strapiContactUs.BackgroundImage.childImageSharp.fluid}/>
        <Img
            className={"contactUSBackgroundImgMobile"}
            alt={contactUs.strapiContactUs.BackgroundImageMobile.childImageSharp.fluid}
            fluid={contactUs.strapiContactUs.BackgroundImageMobile.childImageSharp.fluid}/>
        </div>
       )
};
export default ContactUsBackground;